export const INTERNAL = 'INTERNAL';
export const EXTERNAL = 'EXTERNAL';
export const GAM = 'GAM';
export const UAM = 'UAM';
export const ICC = 'ICC';
export const IOT = 'IOT';
